import copy from 'copy-to-clipboard'

export default function (Vue) {
    Vue.prototype.clipboard = (string) => {
        return copy(string)
    }
}